﻿'use strict';

angular.module('ntmApp')
  .directive('calendarDataProperty', function () {
      return {
          restrict: 'E',
          templateUrl: 'ng1/src/calendar/directives/dataProperty.html',
          scope: {
              data: '='
          },
          link: function (scope) {
              if (!scope.data) {
                  return;
              }

              scope.style = '';

              if (scope.data.labelTextColor) {
                  scope.data.style = 'color: {0};'.format(scope.data.labelTextColor);
              }

              if (scope.data.labelBackgroundColor) {
                  scope.data.style += 'background-color: {0} !important;'.format(scope.data.labelBackgroundColor);
              }

          }
      };
  });